import React from "react";
import "./privatelayout.scss";
import { Outlet, Navigate, useParams } from "react-router-dom";
import Navbar from "../navbar/Navbar";
import SidebarIndividual from "../sidebarIndividual/SidebarIndividual.jsx";
import useAuth from "../../contexts/UserContext.tsx";

const IndividualLayout = () => {
  const { user } = useAuth();
  const { id } = useParams();
  if (
    parseInt(id) !== parseInt(user.view_access_list.schoolID) ||
    !user.view_access_list.mathlab ||
    !user.view_access_list.smartclass
  ) {
    return <h1>Unauthorized</h1>;
  }
  // const user = true
  return user ? (
    <div className="mainLayout">
      <Navbar />
      <div className="subLayout">
        <SidebarIndividual />
        <div className="content">
          <Outlet />
        </div>
      </div>
    </div>
  ) : (
    <Navigate to="login" />
  );
};

export default IndividualLayout;
